export const NOTIFICATIONS_GETTERS = {
    GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
    GET_UNREAD_COUNT: "GET_UNREAD_COUNT"
};